
import { useAdminRoutes } from '@/modules/pe-topos-module/hooks/useAdminRoutes'
import { Fragment, useMemo, } from 'react'
import { Outlet, Route, Routes } from 'react-router'
import Layouts from 'src/libs/layouts'
import DataForm from 'src/modules/pe-admin-module/views/single/DataForm'
import getAllViews from 'src/settings/getAllViews'
import { IFestAdminProps } from '../../data/interfaces'
import Cabinet from './Cabinet'
import CabinetBreadcrumbs from './CabinetBreadcrumbs'
import DataTableForm from './DataTableForm'

const FestAdminForm = (props: IFestAdminProps): JSX.Element => {
    // console.log(  landId )
    const allRoutes = useAdminRoutes()
    let ElComponento: any 
        , ElComponento2: any 
        , schemaElement: any
        , views = useMemo(() => getAllViews(), [])

    // console.log( Object.keys(allRoutes), eventTypeAdminData )
    return <div className='container mb-5'> 
        <Routes>
            <Route path='/*' element={<Form route={props.route} title={props.title} />}>
                <Route 
                    index
                    element={<Cabinet />}
                />
                {
                    Object.keys(allRoutes).map((path: string, i: number) => {
                        if(allRoutes[path].data_type)
                        { 
                            schemaElement = Layouts().schema[ allRoutes[path].data_type ]
                            ElComponento  = !!schemaElement.data_type ? views[schemaElement.data_type] : DataForm
                            ElComponento2 = !!schemaElement.data_type ? views[schemaElement.data_type] : DataTableForm
                            return <Fragment key={ i }> 
                                <Route  
                                    path = { `${ path }/:id` }
                                    element = { 
                                        <ElComponento
                                            hide_title
                                            data_type={ allRoutes[path].data_type }
                                            route={ 
                                                props.route 
                                                    ?
                                                    `${ props.route }/${ path }`
                                                    :
                                                    path 
                                            }
                                        />
                                    }
                                />
                                <Route  
                                    path={ `${path}/*` }
                                    element={ 
                                        <ElComponento2 
                                            hide_title
                                            data_type={ allRoutes[path].data_type } 
                                            path={ 
                                                props.route 
                                                    ?
                                                    `${ props.route }/${ path }`
                                                    :
                                                    path 
                                            }  
                                            title={allRoutes[path].title}
                                        /> 
                                    }
                                />
                            </Fragment> 
                        } 
                        else if(allRoutes[path].component) {                            
                            const Component = allRoutes[path].component 
                            ElComponento = <Component  
                                key={i}
                                route={ path } 
                                title={allRoutes[path].title}
                            />
                        }
                        else
                        { 
                            ElComponento = <div className='display-5' key={i}>
                                {allRoutes[path].title}
                            </div>
                        }
                        return <Route 
                            key={i}
                            path={ `${path}/*` }
                            element={ ElComponento }
                            //element={ <div>{allRoutes[path].title} - component </div> }
                        /> 
                    })
                } 
            </Route>
        </Routes>
    </div>
    
} 

export default FestAdminForm

export const Form = (props:any) :JSX.Element => { 
    return <>
        <div>
            <CabinetBreadcrumbs 
                title={props.title}
                route={props.route}
            />
        </div>
        <div>
           <Outlet />
        </div>
    </>
}